import {rxrGreyColor} from '../../assets/styles/color'
import {spaceExtraExtraSmall, spaceExtraSmall} from '../../assets/styles/spacing'
import {ColumnConfig} from '../SortableTable'
import React from 'react'

const tagLabelStyles = {
  whiteSpace: 'nowrap',
  display: 'inline-block',
  backgroundColor: rxrGreyColor,
  padding: `${spaceExtraExtraSmall}px ${spaceExtraSmall}px`,
  borderRadius: '2px',
  margin: `${spaceExtraExtraSmall}px ${spaceExtraSmall}px ${spaceExtraExtraSmall}px 0`,
}

/**
 * @return {ColumnConfig}
 */
export const getTagLabelsColumnConfig = () =>
  new ColumnConfig({
    title: 'Tags',
    renderPrimitive: item => item.tagsLabel,
    render: r => {
      const tags = r.tags || []
      const tagsCount = tags.length
      const MAX_TAGS_TO_SHOW = 2
      return (
        <div style={{whiteSpace: 'nowrap'}}>
          {tags.slice(0, MAX_TAGS_TO_SHOW).map((tag, index) => (
            <span key={index} style={tagLabelStyles}>
              {tag}
            </span>
          ))}
          {tagsCount > MAX_TAGS_TO_SHOW && <span>+&nbsp;{tagsCount - MAX_TAGS_TO_SHOW}</span>}
        </div>
      )
    },
    comparator: ColumnConfig.simpleComparatorGenerator('tagsLabel'),
  })
